import * as React from 'react'
import * as LDClient from 'launchdarkly-react-client-sdk'
import { defaultFlags } from '../../config/launchDarkly'

const launchDarklyEnabledService = process.env.REACT_APP_LAUNCH_DARKLY_SERVICE === 'true'

export const useFeatureFlags = () => {
	const flags = LDClient.useFlags()

	if (launchDarklyEnabledService && Object.keys(flags).length > 0) {
		return flags
	}

	return defaultFlags
}
